import '../pages.css';
import { Link } from 'react-router-dom';

const FullCast = () => {
    return (
        <div className="page product-detail">
            <section className="product-detail-hero">
                <div className="product-detail-hero-content">
                    <Link to="/products/fixed" className="back-link">← Back to Fixed Prosthetics</Link>
                    <h1>Full Cast</h1>
                    <p className="product-tagline">Time-tested durability and biocompatibility</p>
                </div>
            </section>

            <section className="product-detail-content">
                <div className="content-container">
                    <div className="product-section">
                        <h2>Description</h2>
                        <p>
                            Full-cast restorations remain one of the most time-tested solutions in dentistry. <strong>AbELab</strong> full-cast
                            crowns are fabricated using noble and high-noble alloys, providing unmatched durability, excellent biocompatibility,
                            and minimal wear on opposing dentition. They are particularly suitable for posterior regions where esthetics are less critical.
                        </p>
                    </div>

                    <div className="product-two-column">
                        <div className="product-section">
                            <h2>Indications</h2>
                            <ul>
                                <li>Crowns</li>
                                <li>Veneers</li>
                                <li>Inlays</li>
                                <li>Onlays</li>
                                <li>Bridges</li>
                            </ul>
                        </div>

                        <div className="product-section">
                            <h2>Contraindications</h2>
                            <ul>
                                <li>Partial dentures</li>
                                <li>Implant-supported restorations</li>
                            </ul>
                        </div>
                    </div>

                    <div className="product-section">
                        <h2>Preparation</h2>
                        <ul>
                            <li>Feather-edge margins are ideal</li>
                            <li>Any clinically appropriate margin design may be used</li>
                            <li>Inlays and onlays can also be fabricated as full-cast restorations</li>
                        </ul>
                    </div>

                    <div className="product-section">
                        <h2>Cementation</h2>
                        <ul>
                            <li>Panavia™ 21 (tin plating required for precious alloys)</li>
                            <li>Glass ionomer cement (GC Fuji)</li>
                            <li>Zinc phosphate or polycarboxylate cement</li>
                            <li>Resin ionomer cement (RelyX™)</li>
                        </ul>
                    </div>

                    <div className="product-section">
                        <h2>Technical Notes</h2>
                        <p>All full-cast restorations are fabricated from metal alloys classified by precious metal content:</p>

                        <h3>Alloy Categories</h3>
                        <ul>
                            <li>Base metal: non-precious alloys (e.g., Co-Cr, Titanium)</li>
                            <li>Noble: ≥25% precious metal</li>
                            <li>High noble: ≥60% precious metal (≥40% gold)</li>
                        </ul>

                        <h3>Hardness Types</h3>
                        <ul>
                            <li>Type I: Extra soft</li>
                            <li>Type II: Soft</li>
                            <li>Type III: Hard</li>
                            <li>Type IV: Extra hard (rigid)</li>
                        </ul>

                        <h3>Common Alloys</h3>
                        <ul>
                            <li>Non-Precious / Noble 20 / White High Noble – Type IV</li>
                            <li>Full Cast 40 HN – Type III (Argenco 40)</li>
                            <li>Full Cast 52 HN – Type III (Argenco 52)</li>
                            <li>Full Cast 75 – Type III (Argenco 75, higher gold content)</li>
                        </ul>
                    </div>

                    <div className="product-section product-codes">
                        <h2>Codes</h2>
                        <ul>
                            <li><strong>D2790</strong> – Full-cast crown, high noble metal</li>
                            <li><strong>D2791</strong> – Full-cast crown, predominantly base metal</li>
                            <li><strong>D2792</strong> – Full-cast crown, noble metal</li>
                        </ul>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default FullCast;
